module.exports = __webpack_public_path__ + "media/puzzle7_1.40f69d86.mp3";